<template>
  <div>
    <h5><i class="fas fa-dollar-sign mr-2"></i>Saldo inicial:</h5>
    <div class="row mb-2">
      <div class="col-6 text-muted">Dinheiro:</div>
      <div class="col-6 text-right">{{ openingBalance | decimal }}</div>
    </div>

    <hr />

    <h5><i class="fas fa-arrow-up mr-2" style="color: green"></i>Entradas:</h5>
    <div class="row mb-2">
      <div class="col-6 text-muted">Vendas em dinheiro:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("o", "i") | decimal }}
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-muted">Recebimento de Clientes:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("br", "i") | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-muted">Outras entradas:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("c", "i") | decimal }}
      </div>
    </div>
    <!-- <div class="row mb-2">
      <div class="col-6 text-muted">Entrada de Transferência:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("t", "i") | decimal }}
      </div>
    </div> -->
    <div class="row mb-2">
      <div class="col-6 text-black">Total de Entradas:</div>
      <div class="col-6 text-right">
        <b>{{ totalIn | decimal }}</b>
      </div>
    </div>
    <hr />

    <h5><i class="fas fa-arrow-down mr-2" style="color: red"></i>Saídas:</h5>

    <div class="row mb-2">
      <div class="col-6 text-muted">Devoluções em Dinheiro:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("o", "o") | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-muted">Créditos de clientes:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("br", "o") | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-muted">Pagamentos de contas:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("bp", "o") | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-muted">Outras saidas:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("c", "o") | decimal }}
      </div>
    </div>
    <!-- <div class="row mb-2">
      <div class="col-6 text-muted">Saida de Transferência:</div>
      <div class="col-6 text-right">
        {{ getSumByOriginAndType("t", "o") | decimal }}
      </div>
    </div> -->

    <div class="row mb-2">
      <div class="col-6 text-black">Total de Saídas:</div>
      <div class="col-6 text-right">
        <b>{{ totalOut | decimal }}</b>
      </div>
    </div>
    <hr />
    <div class="row mb-2">
      <h5 class="col-6 text-black">
        <i class="fas fa-equals mr-2"></i>Resultado:
        <br />
        <small class="text-muted">(Entradas - Saidas)</small>
      </h5>
      <h5 class="col-6 text-right">{{ (totalIn + totalOut) | decimal }}</h5>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-black">
        <h5>
          <i class="fas fa-exchange-alt mr-2"></i>Transferências:
        </h5>
      </div>
      <div class="col-6 text-right">
        <span> {{ totalTransfer | decimal }}</span>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6 text-black">
        <h5>
          <i class="fas fa-not-equal mr-2" style="color: red"></i>Diferença:
        </h5>
      </div>
      <div class="col-6 text-right">
        <span> {{ totalDiference | decimal }}</span>
      </div>
    </div>
    <h5><i class="fas fa-dollar-sign mr-2"></i>Saldo final:</h5>
    <div class="row mb-2">
      <div class="col-6 text-muted">Dinheiro:</div>
      <div class="col-6 text-right">{{ closingBalance | decimal }}</div>
    </div>
    <hr />

    <h5><i class="far fa-money-bill-alt mr-2"></i>Vendas e Recebimentos</h5>

    <div class="row mb-2">
      <div class="col-6">Dinheiro:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(1) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Cheque:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(2) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Cartão crédito:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(3) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Cartão débito:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(4) | decimal }}
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-6">Crediário:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(5) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Boleto Bancário </div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(15) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Depósito Bancário </div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(16) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">PIX:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(17) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Carteira Digital:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(18) | decimal }}
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Outros:</div>
      <div class="col-6 text-right">
        {{ getOrderSumByPaymentMethod(99) | decimal }}
      </div>
    </div>
    <hr />
    <div class="row mb-2">
      <div class="col-6">Total em Vendas:</div>
      <div class="col-6 text-right">
        <b>{{ orderSum - billReceivebleSum | decimal }}</b>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-6">Total em Recebimentos:</div>
      <div class="col-6 text-right">
        <b>{{ billReceivebleSum | decimal }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from "../../../mixins/Filters";
import moment from "moment";

export default {
  props: {
    accountResume: {
      default: () => ({
        sumByOrigin: [],
        sumOrderByPaymentMethod: [],
        closingBalance: {
          closingBalance: 0,
        },
        openingBalance: {
          openingBalance: 0,
        },
      }),
    },
  },

  computed: {
    openingBalance() {
      return this.$store.getters["drawer/openingBalance"];
    },

    closingBalance() {
      return this.$store.getters["drawer/closingBalance"];
    },

    totalIn() {
      return this.$store.getters["drawer/totalIn"];
    },

    totalOut() {
      return this.$store.getters["drawer/totalOut"];
    },

    orderSum() {
      return this.$store.getters["drawer/orderSum"];
    },
    billReceivebleSum() {
      return this.$store.getters["drawer/billReceivebleSum"];
    },

    totalDiference() {
      return this.$store.getters["drawer/totalDiference"];
    },

    totalTransfer() {
      return this.$store.getters["drawer/totalTransfer"];
    }
  },

  methods: {
    getSumByOriginAndType(origin, type) {
      return this.$store.getters["drawer/getSumByOriginAndType"](origin, type);
    },

    getOrderSumByPaymentMethod(paymentMethod) {
      return this.$store.getters["drawer/getOrderSumByPaymentMethod"](
        paymentMethod
      );
    },
  },
};
</script>

<style></style>
